import styled from "styled-components";

const MeasureToolbarWrap = styled.section`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
`;
export { MeasureToolbarWrap };
